import { SvgIcon } from '../SvgIcon';
import { styled } from '../muiReexports';
export const SvgIconSpined = styled(SvgIcon)({
    animation: 'fa-spin 2s infinite linear',
});
